module.exports = __webpack_public_path__ + "img/BookStream.a2c2dea2.svg";